import { registerLocaleData } from '@angular/common';
import localeDeCh from '@angular/common/locales/de-CH';
import { bootstrapApplication } from '@angular/platform-browser';
import { init, makeFetchTransport, makeMultiplexedTransport, ErrorEvent } from '@sentry/angular';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale, deLocale } from 'ngx-bootstrap/locale';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { regionUrl, replaceLastOccurenceInString } from '@parashift/shared/utils';
import * as packageJson from '../../../package.json';
import { environment } from './environments/environment';

if (environment.enable_sentry) {
  const { version } = packageJson;
  let region: any = '';

  init({
    dsn: regionUrl(environment.endpoints.sentry),
    transport: makeMultiplexedTransport(makeFetchTransport, () => {
      const dsn = regionUrl(environment.endpoints.sentry, region);

      return [{
        dsn,
        release: 'app-parashift-io@' + replaceLastOccurenceInString(version, '.', '-'),
        attachStacktrace: true,
        ignoreErrors: [
          'Non-Error exception captured'
        ],
        debug: false
      }];
    }),
    beforeSend(event: ErrorEvent) {
      region = event?.tags?.region || '';
      event.environment = region ? String(region).toLowerCase() + '-' + environment.env : environment.env;
      delete event?.tags?.region;
      return event;
    }
  });
}

registerLocaleData(localeDeCh, 'de-CH');
defineLocale('engb', enGbLocale);
defineLocale('de', deLocale);

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
